export default __webpack_public_path__ + "static/g105-696ba10c9cd33a4649765eaf0b42c3ef.jpg";